import Vue from 'vue';
import Vuex from 'vuex';

import User from './modules/user';
import Client from './modules/client';
import Application from './modules/application';
import Installation from './modules/installation';
import Permissions from './modules/permissions';
import SubMenu from './modules/subMenu';
import Notification from './modules/notification';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    User,
    Client,
    Application,
    Installation,
    Permissions,
    SubMenu,
    Notification,
  },
});
